<template>
    <div v-if="show">
        <data-filter />
    </div>
</template>

<script>
import { mapState } from 'vuex'
import DataFilter from '../../../../common/components/DataFilterNew.vue'

export default {
    name: 'ChargeDataFilter',

    components: {
        DataFilter,
    },

    computed: {
        ...mapState({
            activePage: (state) => state.browsing.pageName,
        }),

        show() {
            return (
                this.activePage === 'chargeGraph' ||
                this.activePage === 'chargeTableGlobal'
            )
        },
    },
}
</script>

<style scoped></style>
